import {gestionarEvento} from '../../../utils/eventosService';
import React, { useEffect, useMemo, useState } from 'react';
import './AsignarListaEvento.css';
import { db } from '../../../firebase/firebaseConfig';
import { collection, orderBy, query } from 'firebase/firestore';
import { getDocs } from '../../../utils/firestoreRead';

function fmtFecha(f) {
  if (!f) return '';
  // si viene YYYY-MM-DD
  if (typeof f === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(f)) {
    const [y, m, d] = f.split('-');
    return `${d}/${m}/${y}`;
  }
  return String(f);
}

export default function AsignarListaEvento({ soloEventoId = null, onVolver }) {
  const [eventos, setEventos] = useState([]);
  const [listas, setListas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [savingId, setSavingId] = useState(null);

  const eventosRef = useMemo(() => collection(db, 'eventos'), []);
  const listasRef = useMemo(() => collection(db, 'listasReserva'), []);

  const cargar = async () => {
    setLoading(true);
    setError('');
    try {
      const [eSnap, lSnap] = await Promise.all([
        getDocs(query(eventosRef, orderBy('fechaInicio', 'desc'))),
        getDocs(query(listasRef, orderBy('nombre', 'asc'))),
      ]);
      setEventos(eSnap.docs.map((d) => ({ ...d.data(), id: d.id })).filter((e) => !soloEventoId || e.id === soloEventoId));
      setListas(lSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error(e);
      setError('No se pudieron cargar eventos/listas.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [soloEventoId]);

  const guardar = async (eventoId, listaId) => {
    setSavingId(eventoId);
    try {
      const evento=eventos.find(e=>e.id===eventoId);await gestionarEvento({accion:'publicar',eventoId,revision:evento.revisionConfiguracion||0,solicitudId:crypto.randomUUID(),datos:{...evento,ventasDesdeLista:true,listaReservaId:listaId}});
      await cargar();
    } catch (e) {
      console.error(e);
      alert(e.message||'No se pudo guardar la lista en el evento.');
    } finally {
      setSavingId(null);
    }
  };

  const nombreLista = (id) => listas.find((l) => l.id === id)?.nombre || '';

  // Presentación contextual del evento; comparte lecturas y guardado canónico.
  if (soloEventoId) {
    const evento = eventos[0];
    const asignada = evento?.listaReservaId || '';
    return <div className="ale-event-page"><div className="ale-event-content">
      <header className="ale-header">
        <div><h2>Paquetes de reserva (prepago TOTAL)</h2><p className="ale-sub">Evento: <b>{evento?.nombre || evento?.titulo || soloEventoId}</b>{evento?.fechaTexto ? ` · ${fmtFecha(evento.fechaTexto)}` : ''}</p></div>
        <div className="ale-event-actions"><button className="ale-secondary" type="button" onClick={onVolver}>Volver a eventos</button><button className="ale-secondary" type="button" onClick={cargar}>Recargar</button></div>
      </header>
      {loading ? <div className="ale-card">Cargando…</div> : error ? <div className="ale-error" role="alert">{error}</div> : !evento ? <div className="ale-card">Evento no encontrado.</div> : <>
        <div className="ale-card ale-event-info"><p>Selecciona la lista de paquetes que se ofrecerá al prepagar una reserva.</p><p>Lista asignada: <b>{nombreLista(asignada) || 'Sin lista'}</b>. PREPAGADA corresponde al pago total.</p></div>
        <div className="ale-event-lists">
          {listas.map((lista) => <button key={lista.id} type="button" className={`ale-event-list${asignada === lista.id ? ' is-selected' : ''}`} disabled={savingId === evento.id || lista.activo === false} aria-pressed={asignada === lista.id} onClick={() => guardar(evento.id, lista.id)}>
            <span className="ale-event-marker" aria-hidden="true">{asignada === lista.id ? '✓' : ''}</span><span><strong>{lista.nombre || 'Lista sin nombre'}</strong><span className="ale-event-detail">{(lista.paquetes || []).length} paquete(s){lista.activo === false ? ' · Inactiva' : ''}</span></span><span className="ale-event-status">{savingId === evento.id ? 'Guardando…' : asignada === lista.id ? 'Asignada' : 'Asignar'}</span>
          </button>)}
          {!listas.length && <div className="ale-card">No hay listas de reserva creadas.</div>}
        </div>
        <div className="ale-event-actions ale-event-footer"><button className="ale-secondary" type="button" disabled={savingId === evento.id || !asignada} onClick={() => guardar(evento.id, '')}>Quitar asignación</button><button className="ale-btn" type="button" disabled={savingId === evento.id} onClick={() => guardar(evento.id, asignada)}>{savingId === evento.id ? 'Guardando…' : 'Guardar'}</button></div>
      </>}
    </div></div>;
  }

  return (
    <div className="ale-page">
      <div className="ale-header">
        <div>
          <div className="ale-title">Asignar listas a eventos</div>
          <div className="ale-sub">
            Cada evento debe apuntar a una lista (Viernes/Sábado/Especial). Reservas consumirá esa lista.
          </div>
        </div>
        <button className="ale-secondary" onClick={cargar}>Recargar</button>
      </div>

      {loading && <div className="ale-card">Cargando…</div>}
      {!loading && error && <div className="ale-error">{error}</div>}

      {!loading && !error && (
        <div className="ale-tableWrap">
          <table className="ale-table">
            <thead>
              <tr>
                <th>Evento</th>
                <th>Fecha</th>
                <th>Lista asignada</th>
                <th style={{ width: 360 }}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {eventos.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ padding: 16, opacity: 0.85 }}>
                    No hay eventos creados.
                  </td>
                </tr>
              ) : (
                eventos.map((ev) => (
                  <tr key={ev.id}>
                    <td>
                      <div className="ale-name">{ev.nombre || '(Sin nombre)'}</div>
                      <div className="ale-id">ID: {ev.id}</div>
                    </td>
                    <td>{fmtFecha(ev.fechaTexto)}</td>
                    <td>
                      {ev.listaReservaId ? (
                        <span className="ale-pill ale-pill--on">{nombreLista(ev.listaReservaId) || ev.listaReservaId}</span>
                      ) : (
                        <span className="ale-pill ale-pill--off">Sin lista</span>
                      )}
                    </td>
                    <td>
                      <div className="ale-row">
                        <select
                          className="ale-select"
                          value={ev.listaReservaId || ''}
                          onChange={(e) => guardar(ev.id, e.target.value)}
                          disabled={savingId === ev.id}
                        >
                          <option value="">(Sin lista)</option>
                          {listas
                            .filter((l) => l.activo !== false)
                            .map((l) => (
                              <option key={l.id} value={l.id} disabled={l.activo === false}>
                                {l.nombre}
                              </option>
                            ))}
                        </select>

                        <button
                          className="ale-btn"
                          disabled={savingId === ev.id}
                          onClick={() => guardar(ev.id, ev.listaReservaId || '')}
                          title="Re-guardar"
                        >
                          {savingId === ev.id ? 'Guardando…' : 'Guardar'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
